export default "__VITE_ASSET__b27a7e3e__"